var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrugstore = function SvgDrugstore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.68 9.794h5.877v-4.63c0-.374.306-.68.68-.68h1.7l-.465.806c-1.207 2.09.314 4.49 2.602 4.564 1.131.037 2.095-.559 2.655-1.529l2.218-3.84h.816c.374 0 .68.305.68.679v4.63h5.877c.375 0 .68.306.68.68v16.8c0 .374-.305.68-.68.68h-8.134v-9.791H8.814v9.79H.68a.68.68 0 0 1-.68-.68v-16.8c0-.373.306-.679.68-.679M9.46 5.862l2.804-4.857c1.252-2.168 4.53-.275 3.278 1.893l-2.804 4.856c-1.252 2.168-4.53.276-3.278-1.892m1.563-1.9.376-.653 2.58 1.49-.377.652z",
    clipRule: "evenodd"
  })));
};
export default SvgDrugstore;